import React, { useRef, useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import {
  useFetchCustomerValuesTrackingQuery,
  useLazyCustomerTableNodeQuery,
  useLazyFetchCustFieldHdrQuery,
  useLazyFetchPersonInTableQuery,
  useUpdateCustomerTableDataNodeMutation,
} from "../../utils/customer/customerTable";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import {
  useFetchHeaderConfigurationQuery,
  usePostFieldCreationMutation,
  usePostOptionDeleteMutation,
} from "../../utils/customer/customerListHeader";
import KeyValueSkeleton from "../GlobalFeature/Others/KeyValueSkeleton ";
import EmailHoverElement from "../GlobalFeature/Others/EmailHoverElement";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import {
  checkAccessPermission,
  getCompanyId,
  getDateTimeFormat,
  getOrganizationId,
  getUserToken,
} from "../../utils/utilityFunctions/localServices";
import useDataInputHandlerCopy from "../../hooks/Table/useTableTbodyFireCopy2";
import AddFieldDrawer from "../GlobalFeature/Table/AddFieldDrawer";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import RenderElementsCopy from "../GlobalFeature/Others/RenderElementsCopy";
import AvatarName from "../UniversalComponents/AvatarName";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import { formatNegativeNumber, formatTextValue, safeJsonParse } from "../../utils/utilityFunctions/stringUtility";
import { getUserDateTime } from "../../utils/utilityFunctions/UTCFormat";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import { hexToRgba } from "../../utils/utilityFunctions/color";
import { usePollingWithReset } from "../UniversalComponents/usePollingWithReset";
import { ReactComponent as CrossCancelIcon } from "../../assets/images/crossIconAddTaskPodModal.svg";
import InternalNavigation from "../UniversalComponents/InternalNavigation";
import { ReactComponent as AddIcon } from "../../assets/images/addicon.svg";

const getValueFromFunc = (value) => {
  if (typeof value === "object" && value !== null) {
    return value.value;
  }
  return <div className="min-h-[20px] py-2 w-full text-ellipsis">{value}</div>;
};
const CustomerOtherDetail = ({ custId, onClose, subNavitems, type }) => {
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [loading, setLoading] = useState(true);
  const storedData = localStorage.getItem("company_data");
  const companyId = storedData ? JSON.parse(storedData) : null;
  const [dataInputRow, setDataInputRow] = useState(null);
  const [clientCoord, setClientCoord] = useState({});

  const [extraField, setExtraField] = useState(false);
  const [editFieldData, setEditFieldData] = useState(null);
  const [editModelStatus, setEditModelStatus] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [tablecellInput, setTablecellInput] = useState("");
  const [isAddFieldOpen, setIsAddFieldOpen] = useState(false);
  const modalRef = useClickOutside(() => setExtraField(false));
  const [mappedHeaders, setMappedHeaders] = useState([]);
  const [selectedDateTimeFormat, setSelectedDateTimeFormat] = useState(getDateTimeFormat());
  const freshPollingCounter = useRef(0);
  const dispatch = useDispatch();
  // const handleMenuToggle = () => {
  //   setExtraField(!extraField);
  //   setEditFieldData(null);
  // };
  const params = useParams();
  const isCustIdReceived = !!custId?.id;
  const { id } = custId ? custId : params;
  const customerId = parseInt(id);
  console.log("CustomerOtherDetail customerId", customerId);

  const { token } = useRequireAuth();

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token, data: data, companyId: companyId?.company_id });
  };

  const [
    fetchOptionData,
    { data: optionsData, isSuccess: isSuccessOptions, isFetching: isFetchingOptions, isError: isErrorOptions },
  ] = useLazyCustomerTableNodeQuery();

  const handleFetchOptionData = (data) => {
    fetchOptionData({
      token: getUserToken(),
      orgId: getOrganizationId(),
      companyId: getCompanyId(),
      fieldName: data,
    });
  };

  const [optionsDelete] = usePostOptionDeleteMutation();

  const handleDeleteOption = (choice, fieldName) => {
    if (!choice?.id) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Invalid option ID",
          type: "danger",
        })
      );
      return;
    }

    const payload = {
      id: choice.id,
      company_id: getCompanyId(),
    };

    optionsDelete({ payload })
      .unwrap()
      .then((result) => {
        if (result?.success) {
          dispatch(
            pushAlert({
              visible: true,
              message: result.message || "Option deleted successfully",
              type: "success",
            })
          );
          handleFetchOptionData(fieldName);
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: result.message || "Failed to delete option",
              type: "danger",
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          pushAlert({
            visible: true,
            message: error?.data?.message || "Something went wrong while deleting option",
            type: "danger",
          })
        );
      });
  };
  const [fetchCustomerGetAddField, { data: CustomerGetAddField }] = useLazyFetchCustFieldHdrQuery();

  useEffect(() => {
    setEditFieldData(CustomerGetAddField);
  }, [CustomerGetAddField]);

  const EditExtraField = (e, headeritem) => {
    e.stopPropagation();
    e.preventDefault();
    const filteredItem = customerListHeader?.data?.find((item) => item.value === headeritem);
    //  console.log("filteredItemff", filteredItem?.meta?.textFormat?.textSelectedOption)

    setEditFieldData({
      field_label: filteredItem?.label,
      field_type: filteredItem?.type,
      field_value: filteredItem?.value,
      field_id: filteredItem?.id,
      decimalPlaces: filteredItem?.meta?.numberFormat?.decimalPlaces,
      negativeFormat: filteredItem?.meta?.numberFormat?.negativeFormat,
      selectedOption: filteredItem?.meta?.numberFormat?.selectedOption,
      separators: filteredItem?.meta?.numberFormat?.separators,
      symbol: filteredItem?.meta?.numberFormat?.symbol,
      textSelectedOption: filteredItem?.meta?.textFormat?.textSelectedOption,
      timeDisplay: filteredItem?.meta?.dateTimeFormat?.timeDisplay,
    });

    if (filteredItem?.type === "dropdown" || filteredItem?.type === "multiselect") {
      handleFetchOptionData(filteredItem?.value);
    } else setIsAddFieldOpen(true);
  };

  useEffect(() => {
    //loading
    if (isFetchingOptions) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (isSuccessOptions && !isFetchingOptions) {
      if (optionsData.success) {
        if (editFieldData?.field_value) {
          setEditFieldData((prev) => ({ ...prev, field_options: optionsData.data }));
          setIsAddFieldOpen(true);
        }
      }
    }
    // catch block
    if (isErrorOptions) {
    }
  }, [isSuccessOptions, isFetchingOptions, isErrorOptions]);

  const [updateCustomerTableData, { CustomerDropLoad, CustomerDroperror }] = useUpdateCustomerTableDataNodeMutation();

  const customerTableFieldUpdate = async (item, field_name, header) => {
    const updateData = {
      customer_id: customerId,
      org_id: getOrganizationId(),
      company_id: getCompanyId(),
      field_name: dataInputRow?.columnId,
      value: item,
      linkData: "JHGJ",
    };

    try {
      // setLoading(true);
      const result = await updateCustomerTableData({
        token: getUserToken(),
        data: updateData,
      }).unwrap();

      if (result?.success) {
        customerEditDataRefetch();
        dispatch(
          pushAlert({
            visible: true,
            message: "Data Updated Successfully",
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: "Data Entry Error",
            type: "danger",
          })
        );
      }
    } catch (error) {
      // console.error("Error updating data:", error);
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    } finally {
      // setLoading(false);
    }
  };

  const { handleDataInput } = useDataInputHandlerCopy(handleFetchOptionData, setDataInputRow, setClientCoord);
  // console.log("editFieldData", editFieldData);
  const getStringy = (value) => {
    try {
      const parsedValue = JSON.parse(value);

      if (Array.isArray(parsedValue)) {
        const maxVisible = 3;
        const visibleItems = parsedValue.slice(0, maxVisible);
        const remainingCount = parsedValue.length - maxVisible;

        return (
          <p className="px-2 py-1 rounded w-fit flex flex-wrap gap-2 max-w-full">
            {visibleItems.map((item, index) => {
              const rgbaColor = item?.color_code || item?.code;
              return (
                <span
                  key={index}
                  // style={{
                  //   backgroundColor: item.color_code || item?.code || "transparent",
                  //   color: item.color_code || item?.code ? "white" : "black",
                  //   // border: item.color_code ? "1px solid" : "none",
                  //   borderColor: item.color_code || "transparent",
                  // }}
                  //copied new transparent bg style form responsive tags

                  style={{
                    backgroundColor: hexToRgba(rgbaColor, 0.1),
                    color: rgbaColor ? hexToRgba(rgbaColor) : "black",
                    // border: rgbaColor ? `0.8px solid ${rgbaColor}` : "none",
                    borderRadius: "3px",
                    whiteSpace: "nowrap",
                  }}
                  className="px-2 py-0.5 text-[12px]  rounded text-white whitespace-nowrap"
                >
                  {item.value || "--"} {!item.color_code && !item?.code && " ;"}
                </span>
              );
            })}

            {remainingCount > 0 && (
              <span className="inline-flex h-6 min-w-[16px] items-center justify-center px-1 text-[10px] border rounded text-[#505E70] shadow shadow-card leading-none">
                +{remainingCount}
              </span>
            )}
          </p>
        );
      }

      if (typeof parsedValue === "object" && parsedValue?.value) {
        const rgbaColor =
          parsedValue?.color_code || parsedValue?.color_code ? `${parsedValue.color_code}99` : undefined;
        return (
          <p
            className="px-2 py-1 rounded w-fit max-w-[10vw] text-ellipsis overflow-hidden"
            style={{
              backgroundColor: rgbaColor,
              color: rgbaColor ? "white" : "black",
            }}
          >
            {parsedValue.value}
          </p>
        );
      }
    } catch (error) {}
    return <p className="text-ellipsis overflow-hidden ">{getUserDateTime(value)}</p>;
    // {getUserDateTime(
    //                   sampleDatetime,

    //                   selectedDateTimeFormat.dateFormate,
    //                   selectedDateTimeFormat.timeFormate
    //                 )}
  };

  const handleOtherDetailChange = (header, item, columnKey, event, type) => {
    // console.log("handleOtherDetailChange", columnKey);

    event.stopPropagation();
    event.preventDefault();

    if (!dataInputRow?.rowIndex) {
      handleDataInput(header, item, columnKey, event, type);
    }
  };

  const {
    data: customerEditData,
    refetch: customerEditDataRefetchOnly,
    isLoading,
  } = useFetchCustomerValuesTrackingQuery({
    token: getUserToken(),
    params: {
      org_id: getOrganizationId(),
      company_id: getCompanyId(),
      customer_id: customerId,
    },
  });

  const customerEditDataRefetch = useCallback(() => {
    freshPollingCounter.current = 0;
    customerEditDataRefetchOnly();
  }, [customerEditDataRefetchOnly, freshPollingCounter]);

  const refetchPollingData = () => {
    freshPollingCounter.current += 1;
    customerEditDataRefetchOnly();
  };

  usePollingWithReset(refetchPollingData, [customerEditData], 10000, true, "Task Table");

  useEffect(() => {
    if (!isLoading) {
      setLoading(false);
    }
  }, [isLoading]);

  useEffect(() => {
    if (customerId && token) {
      customerEditDataRefetch();
    }
  }, [customerId, token]);

  const dataitem = customerEditData?.data[0];
  const {
    data: customerListHeader,
    refetch: refetchHeader,
    isLoadingHeader,
  } = useFetchHeaderConfigurationQuery({
    token: getUserToken(),
    params: {
      org_id: getOrganizationId(),
      company_id: getCompanyId(),
      tracking: true,
    },
  });

  // const mappedHeaders =
  //   customerListHeader?.data?.map((headerItem) => ({
  //     key: headerItem["value"],
  //     label: headerItem["label"],
  //     //statuskey: Object.keys(headerItem)[1],
  //     statuslabel: headerItem["visibilty"] ? "1" : "0",
  //     ...headerItem,
  //   })) || [];

  useEffect(() => {
    if (customerListHeader?.data) {
      const newMappedHeaders = customerListHeader?.data?.map((headerItem) => ({
        key: headerItem["value"],
        label: headerItem["label"],
        //statuskey: Object.keys(headerItem)[1],
        statuslabel: headerItem["visibilty"] ? "1" : "0",
        ...headerItem,
      }));
      setMappedHeaders(newMappedHeaders);
    }
  }, [customerListHeader?.data]);

  const tableDetail = {
    tableidclass: "customerotherdetail",
  };

  const tableCellChange = (e) => {
    setTablecellInput(e.target.value);
  };

  const updateTableField = (e, item, completedata, header) => {
    //e.stopPropagation();

    customerTableFieldUpdate(item, completedata, header);
    setDataInputRow(null);
  };

  useEffect(() => {
    // console.log("mappedHeader", mappedHeaders);
  }, [mappedHeaders]);

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };
  const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
    ({ theme }) => ({
      [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "white",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 320,
        // minHeight:100,
        maxHeight: 100,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9",
      },
    })
  );

  const [postFieldCreation, { isSuccess: isFieldCreationSuccess }] = usePostFieldCreationMutation();

  const handleAddUpdateField = async (fielddata, isUpdate) => {
    // console.log(fielddata, customerListHeader, "helloField");

    const payload = {
      org_id: getOrganizationId(),
      company_id: getCompanyId(),
      ...fielddata,
    };

    try {
      const result = await postFieldCreation({ payload, isUpdate: isUpdate ? true : false }).unwrap();
      if (result?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: result?.message,
            type: "success",
          })
        );
        setIsAddFieldOpen(false);
        refetchHeader();
        customerEditDataRefetch();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: result?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const getPersonAvatar = (personList, header, rowKey) => {
    return (
      <div className="w-full">
        <div className="pt-1 space-x-1 flex items-end">
          {Array.isArray(personList) &&
            personList
              ?.filter((assigned, index) => index < 3)
              .map((eachInput, index) => {
                const initials = eachInput.name
                  .split(" ")
                  .filter((word) => word.length > 0)
                  .map((word) => word.charAt(0).toUpperCase())
                  .slice(0, 2)
                  .join("");
                const fullName = eachInput.name;

                return (
                  <div key={index} className="relative">
                    <Tooltip
                      title={
                        <>
                          <div className="py-2 min-w-[249px]">
                            <div className="rounded-lg bg-white">
                              <div className="border-b-2 space-y-2 pb-2">
                                <div className="flex px-2 space-x-2">
                                  <div>
                                    <AvatarName
                                      name={initials}
                                      size="small"
                                      bgColor={"#E8ECF299"}
                                      textColor={"#7C7C83"}
                                      borderColor={"#ABABAC"}
                                    />
                                  </div>
                                  <div className="text-2999BC text-14">{fullName}</div>
                                </div>

                                <div className="flex px-2 space-x-2 my-2">
                                  <div className="w-5 text-center">
                                    <EmailIcon />
                                  </div>
                                  <div className="text-F16136 text-12">{eachInput?.email}</div>
                                </div>

                                <div className="flex px-2 space-x-2 my-2">
                                  <div className="w-5 text-center">
                                    <PhoneIcon />
                                  </div>
                                  <div className="text-F16136 text-12">
                                    {eachInput.mobile ? eachInput?.mobile : "Not Avaliable"}
                                  </div>
                                </div>
                              </div>
                              {/* <div className="flex justify-end mt-2 me-5 text-12">
                                  <button
                                    className="text-blue-500"
                                    // onClick={(e) => toggleDetails(e, header, rowKey, eachInput)}
                                  >
                                    {isDetailsVisible ? "Show more" : "Show more"}
                                  </button>
                                </div> */}
                            </div>
                            <div></div>
                          </div>
                        </>
                      }
                      PopperProps={{ style: { zIndex: 99999 } }}
                      placement="top"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "common.white",
                            filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                            color: "#383838",
                            "& .MuiTooltip-arrow": {
                              color: "common.white",
                              filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                            },
                          },
                        },
                      }}
                    >
                      <div
                        className={` ${eachInput?.c_key ? "text-white border-white" : "text-[#7C7C83] border-[#ABABAC]"} text-12 font-400   p-[10px] w-7 h-7 flex items-center justify-center rounded-full border-[1px]`}
                        style={{ backgroundColor: eachInput?.c_key ? eachInput?.c_key : "#E8ECF2" }}
                      >
                        {initials}
                      </div>
                    </Tooltip>

                    {/* <button
                  className="absolute top-[-4px] right-[-4px] bg-blue-500 text-white rounded-full w-[10px] h-[10px] flex items-center justify-center text-xs cursor-pointer"
                // onClick={(e) => handleSelectPerson(e, eachInput)} */}
                    {/* >
                  &times;
                </button> */}
                  </div>
                );
              })}

          {personList?.length > 3 && (
            <div className="">
              <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300 w-7 h-7 flex items-center justify-center rounded-full border-[1px] ">
                +{personList?.length - 3}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="tablemaindiv flex flex-col h-full bg-[#fcfbfc] gap-2">
      {successMessage && <p className="text-green-500 text-right ">{successMessage}</p>}
      <div
        className={`flex justify-between ${isCustIdReceived ? "p-3" : "border-b border-[#E9E9E9]"}  sticky top-0 bg-white z-[1]   `}
      >
        {/* <div className="focus:pb-2 px-3 block leading-normal text-20 font-600 font-Vietnam text-203C50 capitalize self-end ">
          <h3>Tracking</h3>
        </div> */}
        <div className="flex justify-between">
          <h4 className={`${!subNavitems && "text-537596 text-xl capitalize  font-500 pb-[-5px]"}`}>
            {subNavitems ? (
              <InternalNavigation items={subNavitems} subTabValue={"tracking"} />
            ) : isCustIdReceived ? (
              "Edit Row Items"
            ) : (
              "Tracking"
            )}{" "}
          </h4>
        </div>
        {isCustIdReceived ? (
          <div className="flex items-center justify-center gap-4">
            <div className="flex items-center justify-between">
              {" "}
              <CrossCancelIcon className="cursor-pointer" onClick={onClose} />{" "}
            </div>
          </div>
        ) : (
          <div>
            {!isCustIdReceived && (
              <button
                onClick={() => setIsAddFieldOpen(true)}
                disabled={editModelStatus}
                className="cursor-pointer border border-[#d2dae1] rounded-md   bg-[#F1F6F9] hover:bg-[#DFF2FE] flex items-center gap-2 px-3 py-1.5"
              >
                <AddIcon isActive={isAddFieldOpen} className="h-5 w-5" />
                <span className="text-[#2999BC] text-base font-500">Add New</span>
              </button>
            )}
          </div>
        )}
      </div>

      <form className="bg-white p-5 h-auto overflow-y-auto">
        <div
          className={`flex flex-wrap md:justify-between gap-[6px] ${tableDetail.tableidclass}`}
          id={`${tableDetail.tableidclass}`}
        >
          {loading
            ? Array(8)
                .fill()
                .map((_, index) => <KeyValueSkeleton key={index} />)
            : mappedHeaders &&
              mappedHeaders?.map((header, index) => {
                const key = header?.key;
                const { separators, decimalPlaces, negativeFormat, selectedOption, symbol } =
                  header?.meta?.numberFormat || {};
                const { textSelectedOption } = header?.meta?.textFormat || {};

                if (dataitem && dataitem.hasOwnProperty(key)) {
                  const matchingData = dataitem[key];
                  let parsedvalue = matchingData;
                  return (
                    <div
                      className=" h-[40px] mb-6 md:mb-0 relative flex items-center   border rounded-md"
                      key={index}
                      style={{ width: isCustIdReceived ? "97%" : "47%" }}
                    >
                      <div
                        className={`bg-[#F1F6F9] w-[40%] h-[100%] flex items-center justify-between p-4 rounded-tl-lg rounded-bl-lg ${
                          isCustIdReceived ? "" : "labelhoverpencilshow"
                        }`}
                      >
                        <label
                          className="col-span-5 tracking-wide text-535252 text-[13px]  capitalize  "
                          htmlFor="status"
                        >
                          {/* {matchingData?.field_label} */}
                          {header?.label}
                        </label>
                        {
                          <button
                            type="button"
                            className="pencilicon ms-5"
                            onClick={(e) => {
                              EditExtraField(e, header.key);
                            }}
                            disabled={!checkAccessPermission("Add & Edit Customer") || Boolean(dataInputRow)}
                            style={{ visibility: checkAccessPermission("Add & Edit Customer") ? "visible" : "hidden" }}
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                        }
                      </div>
                      <div className={`col-span-7 relative bg-white w-[60%] h-full text-ellipsis px-1 ps-4`}>
                        {dataInputRow && dataInputRow?.rowId === header?.label ? (
                          <RenderElementsCopy
                            tableDetail={tableDetail}
                            fetchPersonInTable={fetchPersonData}
                            Item={dataitem}
                            Header={{ ...header }}
                            RowKey={matchingData?.field_label}
                            CommonData={optionsData}
                            CellChange={tableCellChange}
                            CellInput={tablecellInput}
                            setDataRow={setDataInputRow}
                            DataRow={dataInputRow}
                            UpdateField={updateTableField}
                            clientCoord={clientCoord}
                            cell={{ column: { id: header.key } }}
                            isTracking // this is to resize the datepicker component as per need in the tracking page
                            meta={header?.meta}
                          />
                        ) : (
                          <div
                            className="clickopennow cursor-pointer labelhoverpencilshow accounting-ellipsis flex items-center justify-between h-full "
                            onClick={(event) => {
                              handleOtherDetailChange(header.label, dataitem, header?.key, event, header.type);
                            }}
                          >
                            <div>
                              <button type="button" className="pencilicon mx-1 mr-2">
                                <i className="bi bi-pencil"></i>
                              </button>
                            </div>
                            {header?.type === "dropdown" || header?.type === "Listbox" ? (
                              <div
                                // style={{
                                //   backgroundColor: JSON.parse(parsedvalue)?.color_code,
                                //   borderColor: JSON.parse(parsedvalue)?.color_code,
                                // }}
                                //

                                //copied new transparent bg style form responsive tags
                                style={{
                                  backgroundColor: hexToRgba(JSON.parse(parsedvalue)?.color_code, 0.1),
                                  color: JSON.parse(parsedvalue)?.color_code
                                    ? hexToRgba(JSON.parse(parsedvalue)?.color_code)
                                    : "black",
                                  // border: JSON.parse(parsedvalue)?.color_code
                                  //   ? `0.8px solid ${JSON.parse(parsedvalue)?.color_code}`
                                  //   : "none",
                                  borderRadius: "5px",
                                  whiteSpace: "nowrap",
                                }}
                                className={`inline-block text-black  ${safeJsonParse(parsedvalue)?.color_code && " rounded-[5px] text-white  accounting-ellipsis"} text-[12px] px-2 min-h-[20px] text-ellipsis`}
                              >
                                {JSON.parse(parsedvalue)?.value || "--"}
                              </div>
                            ) : ["person", "multi_person"].includes(header?.type) ? (
                              <div
                                className={`inline-block text-black  ${safeJsonParse(parsedvalue)?.color_code && " rounded-[5px] text-white  accounting-ellipsis"} text-[12px] px-2 min-h-[20px] text-ellipsis`}
                              >
                                {getPersonAvatar(safeJsonParse(parsedvalue))}
                              </div>
                            ) : header?.type === "number" ? (
                              formatNegativeNumber(
                                parsedvalue,
                                negativeFormat,
                                selectedOption,
                                decimalPlaces,
                                separators,
                                symbol
                              )
                            ) : header?.type === "text" ? (
                              formatTextValue(parsedvalue, textSelectedOption, false, header.meta)
                            ) : parsedvalue?.value ? (
                              <HtmlTooltip
                                arrow
                                disableHoverListener={!Boolean(getValueFromFunc(parsedvalue?.value || ""))}
                                title={
                                  <React.Fragment>
                                    <div className="max-w-[320px] overflow-auto  ">{parsedvalue?.value || ""}</div>
                                  </React.Fragment>
                                }
                              >
                                <div
                                  className={`inline-block max-w-full  overflow-hidden  accounting-ellipsis ps-1 text-black  ${parsedvalue?.color_code && "border rounded-[68px] "}

                                                                     text-ellipsis       text-[12px] `}
                                >
                                  {getValueFromFunc(parsedvalue?.value || "--")}
                                </div>
                              </HtmlTooltip>
                            ) : (
                              <div
                                className={`inline-block max-w-full  overflow-hidden  accounting-ellipsis  text-black  ${parsedvalue?.color_code && "border rounded-[68px] "}

                                                                            text-[12px] `}
                              >
                                {getStringy(parsedvalue)}
                              </div>
                            )}

                            {matchingData && matchingData?.type === "person" && (
                              <EmailHoverElement
                                ParentId={tableDetail}
                                Data={parsedvalue}
                                HoverActiveClass={"tablehoverelement"}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
                return null;
              })}
        </div>
      </form>

      {isAddFieldOpen && (
        <AddFieldDrawer
          open={isAddFieldOpen}
          onClose={() => {
            setIsAddFieldOpen(false);
            setEditFieldData(null);
          }}
          ExtraFieldAddHeader={handleAddUpdateField}
          EditFieldData={editFieldData}
          handleDeleteOption={handleDeleteOption}
          headerData={customerListHeader?.data}
        />
      )}
    </div>
  );
};

export default CustomerOtherDetail;
